<script setup lang="ts">
import './_index.scss'
import type { Props } from './types'

defineProps<Props>()

const { t } = useI18n()

</script>

<script lang="ts">
export default {
  name: 'PdAmenitiesList'
}
</script>

<template>
  <section
    class="pd-amenities mt-32">
    <h3 class="pd-amenities__title">
      <span>
        {{ t('amenities.title') }}
      </span>
      {{ t('amenities.subTitle') }}
    </h3>

    <ul class="pd-amenities__list-container">
      <li
        v-for="(amenitie, index) in amenitiesList"
        :key="index">
        {{ amenitie }}
      </li>
    </ul>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
